//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
    async fetch() {
      let query = {
        slug: this.$route.params.slug,
        query: this.queries.newsitem
    };
    await Promise.all([ 
     this.$store.dispatch('resourcesStore/getResource', query),
     this.$store.dispatch('bannerStore/getBanner', 'resource'),
     this.$store.dispatch('resourcesStore/countResource', {
        id: this.$route.params.slug
    })
 ])
},
head() {
    return {
        title: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.title : 'Nieuwsbericht | Nieuws | Meiden van Holland',
        meta: [
            { hid: 'title', name: 'title', content: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.title : 'Nieuwsbericht | Nieuws | Meiden van Holland'},
            { hid: 'og:title', name: 'og:title', content: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.title : 'Nieuwsbericht | Nieuws | Meiden van Holland'},
            { hid: 'twitter:title', name: 'twitter:title', content: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.title : 'Nieuwsbericht | Nieuws | Meiden van Holland'},
            { hid: 'description', name: 'description', content: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.description : 'Geil nieuwsbericht van Meiden van Holland over lekkere sexfilms'},
            { hid: 'og:description', name: 'og:description', content: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.description : 'Geil nieuwsbericht van Meiden van Holland over lekkere sexfilms'},
            { hid: 'twitter:description', name: 'twitter:description', content: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.description : 'Geil nieuwsbericht van Meiden van Holland over lekkere sexfilms'},
            { hid: 'og:url', name: 'og:url', content: this.newsitem && this.newsitem.slug ? 'https://meidenvanholland.nl/nieuws/' + this.newsitem.slug : 'https://meidenvanholland.nl/nieuws/'},
                { hid: 'twitter:url', name: 'twitter:url', content: this.newsitem && this.newsitem.slug ? 'https://meidenvanholland.nl/nieuws/' + this.newsitem.slug : 'https://meidenvanholland.nl/nieuws/'},
                    { hid: 'keywords', name: 'keywords', content: this.newsitem && this.newsitem.seo && this.newsitem.seo ? this.newsitem.seo.keywords : 'nieuws, nieuwsbericht, pornoster, Meiden van Holland'},
                    { hid: 'og:image', name: 'og:image', content: this.newsitem.images && this.newsitem.images.data && this.newsitem.images.data.thumb && this.newsitem.images.data.thumb[0] ? process.env.CDN + this.newsitem.images.data.thumb[0] : ''},
                    { hid: 'twitter:image', name: 'twitter:image', content: this.newsitem.images && this.newsitem.images.data && this.newsitem.images.data.thumb && this.newsitem.images.data.thumb[0] ? process.env.CDN + this.newsitem.images.data.thumb[0] : ''},
                    { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image'},
                ],
            }
        },
        components: {
            breadcrumbs: () => import('~/components/breadcrumbs'),
            thumb: () => import('~/components/thumb'),
            dummy: () => import('~/components/content/dummy/default'),
            error: () => import('~/components/error.vue')
        },
        computed: {
            ...mapState({
                queries: ({ resourcesStore: {queries} }) => queries,
                newsitem: ({ resourcesStore: {newsitem} }) => newsitem,
                loading: ({ resourcesStore: {loading} }) => loading
            }),
        },
    }
